<template>
    <h2>Production Pages</h2>
    <div    class="flex justify-around">
        <div    class="w-3/5 grid-cols-12">
            <!-- List of links that should be shown -->
            <ul class="mt-3 grid grid-cols-1 gap-5 sm:gap-5 md:grid-cols-2">
                <!-- Grab each links -->
                <template v-for="link in links">
                    <li     v-if="linkHasPermission(link) && meetsRequirements(link)"
                        class="col-span-1">
                        <!-- Link to page -->
                        <setting-page-link-with-icon    :href="link.link"
                                                        :icon="link.icon"
                                                        :text="link.text"
                        ></setting-page-link-with-icon>
                    </li>
                </template>
            </ul>
        </div>
    </div>
</template>

<script>
import axios from "axios"
import _ from 'lodash'
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import SettingPageLinkWithIcon from "@/components/SonicuSidebar/SettingPageLinkWithIcon.vue";
import {SidebarLinksPageMixin} from "@/mixins/SidebarLinksPageMixin";

export default {
    name: "ProductionLinksPage",
    mixins: [SonicuCoreMixin, iconNamesMixin, SidebarLinksPageMixin],
    components: {SettingPageLinkWithIcon},
    emits: [],
    props: {},
    data() {
        return {
            canEnableIsoProbeTypes: false,

            links: [
                {
                    text: 'Device Association (Set)',
                    link: '/device-association/set-associations',
                    permission: 'read_device_association',
                    icon: 'icon-register',
                },
                {
                    text: 'Device Association (View)',
                    link: '/nova/resources/device-associations',
                    permission: ['read_device_association', SidebarLinksPageMixin.NOVA_ACCESS_PERMISSION],
                    icon: 'icon-page-break2',
                },
                {
                    text: 'Register Calibrated Probes',
                    link: '/probe-calibration/register-calibrations',
                    permission: 'manage_probe_calibrations',
                    icon: 'icon-license',
                },
                {
                    text: 'Automated Probe Calibration',
                    link: '/probe-calibration/automated',
                    permission: 'manage_probe_calibrations',
                    icon: 'icon-cog',
                },
                {
                    text: 'Probe Calibration',
                    link: '/nova/resources/probe-calibrations',
                    permission: ['view_probe_calibrations', SidebarLinksPageMixin.NOVA_ACCESS_PERMISSION],
                    icon: 'icon-menu2',
                },
                {
                    text: 'Shipping Checklist',
                    link: '/shipping-checklist',
                    permission: 'view_shipping_checklist',
                    icon: 'icon-list3',
                },
                {
                    text: 'Probe Association',
                    link: '/probe-association',
                    permission: 'manage_probe_calibrations',
                    icon: 'icon-menu3',
                },
                {
                    text: 'Sonilink Hubs',
                    link: '/nova/resources/sonilink-hubs',
                    permission: 'read_device_association',
                    icon: 'icon-communication',
                },
                {
                    text: 'Multi-Point Calibration Profiles',
                    link: '/multi-point-calibration-profiles',
                    permission: 'view_multi_point_calibration_profile',
                    icon: 'icon-license',
                },
                {
                    text: 'Probe Type - ISO Enabled',
                    link: 'iso-probe-types',
                    permission: null,
                    icon: 'icon-license',
                    requirements: [
                        () => this.canEnableIsoProbeTypes,
                    ],
                },

            ],
        }
    },
    created() {
        this.links = this.parseCompanyLinks(this.links)
    },
    mounted() {
        axios.get(this.company.buildApiInternalRoute('is-production-manager')
        ).then(response => {
            let data = response.data
            this.canEnableIsoProbeTypes = data.isProductionManager
            this.$forceUpdate()
        })
    },
    methods: {
        meetsRequirements (linkInfo) {
            // In Link Info there may be a list of requirements listed
            if (! linkInfo.requirements) {
                return true
            }

            for (const requirement of linkInfo.requirements) {
                // Each Requirement is a lambda that returns true/false
                let passRequirements = requirement()

                // If any requirement fails, return false
                if (! passRequirements) {
                    return false
                }
            }

            return true
        },
    },
    computed: {},
    watch: {},
}
</script>

<style scoped>

</style>